<template>
  <div class="mx-auto md:w-1/2 py-5">
    <div class="flex flex-col py-2">
      <label for="website" class="block"> Current Password </label>
      <SingleLineInput
        id="currentPassword"
        type="password"
        :value="currentPassword"
        @input="currentPassword = $event.target.value"
      ></SingleLineInput>
    </div>

    <div class="flex flex-col py-2">
      <label for="website" class="block"> New Password </label>
      <SingleLineInput
        id="newPassword"
        type="password"
        :value="newPassword"
        @input="newPassword = $event.target.value"
      ></SingleLineInput>
    </div>

    <div class="flex flex-col py-2">
      <label for="website" class="block"> Confirm New Password </label>
      <SingleLineInput
        id="matchPassword"
        type="password"
        :value="matchPassword"
        @input="matchPassword = $event.target.value"
      ></SingleLineInput>
    </div>

    <PasswordGuide :password="matchPassword" ref="passwordGuide" />

    <div class="flex flex-col md:w-1/2 mx-auto py-5">
      <PrimaryButton
        @click="updatePassword"
        :disabled="!passwordValid || isUserLoading"
        :is-loading="isUserLoading"
        >Update Password
      </PrimaryButton>
    </div>
  </div>
  <ActionToast ref="passwordToast" />
</template>
<script>
import { mapGetters } from "vuex"
import { USER_UPDATE_PASSWORD } from "@/store/types"

export default {
  computed: {
    ...mapGetters(["getCurrentUser", "isUserLoading"]),
    passwordValid() {
      return (
        !!this.newPassword &&
        !!this.matchPassword &&
        this.newPassword === this.matchPassword &&
        this.$refs.passwordGuide.isValid
      )
    }
  },
  data() {
    return {
      currentPassword: "",
      newPassword: "",
      matchPassword: "",
      errorMessage: ""
    }
  },
  methods: {
    resetData() {
      this.currentPassword = ""
      this.newPassword = ""
      this.matchPassword = ""
      this.errorMessage = ""
    },
    async updatePassword() {
      const { newPassword, currentPassword } = this

      try {
        await this.$store.dispatch(USER_UPDATE_PASSWORD, {
          newPassword,
          currentPassword
        })

        this.$refs.passwordToast.show({
          type: "success",
          hasClose: true,
          content: "Password Updated!",
          icon: "check"
        })
      } catch (err) {
        if (err.response && err.response.data.error) {
          this.errorMessage = err.response.data.error
        } else {
          this.errorMessage = "Incorrect password. Please try again."
        }
        this.$refs.passwordToast.show({
          type: "danger",
          hasClose: true,
          content: this.errorMessage
        })
      }
      this.resetData()
    }
  }
}
</script>
